import { render, staticRenderFns } from "./ModalExtraDataSections.vue?vue&type=template&id=7d72d926&"
import script from "./ModalExtraDataSections.vue?vue&type=script&lang=js&"
export * from "./ModalExtraDataSections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports